import PropTypes from 'prop-types';
import React from 'react';
import PaginationLink from 'common/components/PaginationLink';

class Pagination extends React.Component {
  // NOTE: Out of date with actual type for props
  static propTypes = {
    currentPage: PropTypes.number,
    onPageChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    currentPage: 1
  };

  render() {
    const { currentPage, totalPages, onPageChange } = this.props;

    const firstPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={1}
        className="button small secondary"
        href={this.props.firstPageURL}
      >
        «
      </PaginationLink>
    );

    const lastPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={totalPages}
        className="button small secondary"
        href={this.props.lastPageURL}
      >
        »
      </PaginationLink>
    );

    const previousPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={currentPage - 1}
        className="button small"
        href={this.props.previousPageURL}
        rel="prev"
      >
        ‹
        <span className="m-pagination-button-text">
          {__('search.pagination.previous')}
        </span>
      </PaginationLink>
    );

    const nextPageLink = (
      <PaginationLink
        onClick={onPageChange}
        page={currentPage + 1}
        className="button small"
        href={this.props.nextPageURL}
        rel="next"
      >
        <span className="m-pagination-button-text">
          {__('search.pagination.next')}
        </span>
        ›
      </PaginationLink>
    );

    if (this.props.totalPages > 1) {
      return (
        <div className="m-pagination-container">
          <ul className="m-pagination">
            {currentPage !== 1 && <li>{firstPageLink} </li>}
            {currentPage !== 1 && <li>{previousPageLink} </li>}
            <li className="m-pagination-count">
              {__('search.pagination.page')} <strong>{currentPage}</strong> /{' '}
              {totalPages}
            </li>
            {currentPage !== totalPages && <li> {nextPageLink}</li>}
            {currentPage !== totalPages && <li> {lastPageLink}</li>}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Pagination;
